var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVdr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.7502H7.12327L19.9509 29.4998L16.3721 35L0 8.7502Z",
    fill: "url(#paint0_linear_25128_7703)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9121 21.8746L20.8789 28.2498L38.8421 -0.00012207H30.6787L16.9121 21.8746Z",
    fill: "url(#paint1_linear_25128_7703)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25128_7703",
    x1: -1.34105,
    y1: 0.918344,
    x2: 25.1537,
    y2: 39.6031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A4721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AE7D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C89D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3CF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBD98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D1A757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B48532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AA7825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25128_7703",
    x1: 23.2071,
    y1: 7.47144,
    x2: 32.4322,
    y2: 16.6965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A4721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AE7D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C89D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3CF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBD98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D1A757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B48532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AA7825"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdr);
export default __webpack_public_path__ + "static/media/VDR.46bab083e50fc0a540137b852bf0c9fe.svg";
export { ForwardRef as ReactComponent };